import React from 'react'
import PropTypes from 'prop-types'
import { Switch as RouterSwitch, Redirect, withRouter } from 'react-router-dom'
import PrivateRoute from '../../hocs/PrivateRoute'
import ProductsPage from './ProductsPage'
import OrdersList from './OrdersList'
import OrderDetail from './OrderDetail'
import SupplierPage from './SupplierPage'
import ConversationDetail from '../DutyAssistant/Conversations/Detail'
import { VehicleHistoryConversationsList } from '../DutyAssistant/Conversations'

// The vehicle-history section's own router. Orders is the landing page, not Products: the
// packages are set up once and the orders are read every day.
//
// The order detail is a page rather than a drawer for tracking's reason — it is the target of a
// Telegram deep link, so somebody opens `/vehicle-history/orders/{id}` cold, on a phone, and it
// has to resolve on its own.
const VehicleHistoryRoutes = ({ match }) => (
  <RouterSwitch>
    <Redirect exact from={match.path} to={`${match.path}/orders`} />
    <PrivateRoute exact path={`${match.path}/orders`} component={OrdersList} />
    <PrivateRoute exact path={`${match.path}/orders/:id`} component={OrderDetail} />
    {/* This module's WhatsApp conversations only (owner, 2026-10-29). */}
    <PrivateRoute
      exact
      path={`${match.path}/conversations`}
      component={VehicleHistoryConversationsList}
    />
    <PrivateRoute
      exact
      path={`${match.path}/conversations/:id`}
      component={ConversationDetail}
    />
    <PrivateRoute exact path={`${match.path}/products`} component={ProductsPage} />
    <PrivateRoute exact path={`${match.path}/supplier`} component={SupplierPage} />
    {/* The API's Telegram account alerts link here; the page they mean is the supplier one. */}
    <Redirect exact from={`${match.path}/account`} to={`${match.path}/supplier`} />
  </RouterSwitch>
)

VehicleHistoryRoutes.propTypes = { match: PropTypes.object }

export default withRouter(VehicleHistoryRoutes)
